import ShareUrl from 'components/ShareUrl';
import StatusPill from 'components/StatusPill';
import Tooltip from 'components/Tooltip';
import CopyButton from 'components/CopyButton';
import getTypeFromUgcRequest from 'helpers/getTypeFromUgcRequest';
import routeFor from 'helpers/routeFor';
import routes from 'helpers/routes';
import { IconLink } from 'icons';
import { useTranslation } from 'react-i18next';
import UgcRequest from 'types/UgcRequest';
import { ExpiresAt } from './components';
import { LumenButton } from '@photoshelter/socialie-components';
import { Link } from 'react-router-dom';

interface Props {
  ugcRequest: UgcRequest;
}

export default function UgcRequestTopBar({ ugcRequest }: Props) {
  const { t } = useTranslation();
  const subject = ugcRequest.subject || t('global.noSubject');

  return (
    <div className="border-b-default sticky top-0 z-50 h-8 bg-white">
      <div className="flex h-full justify-between p-2 pl-3">
        <div className="flex min-w-0 items-center">
          <div
            className="max-w-20 min-w-0 truncate h5 desktop:max-w-40 large:max-w-50"
            title={subject}
          >
            {subject}
          </div>
          <div className="hidden min-w-0 items-center tablet:flex">
            {getTypeFromUgcRequest(ugcRequest) === 'live' && (
              <div className="bump-down-2 ml-1 min-w-0">
                <StatusPill
                  ugcRequest={ugcRequest}
                  size="small"
                  theme="normal"
                  statusTextClasses="hidden desktop:block bump-up-1"
                />
              </div>
            )}
            <div className="hidden min-w-0 tablet:block">
              <ExpiresAt ugcRequest={ugcRequest} tooltipPlacement="bottom" />
            </div>
          </div>
        </div>
        <div className="flex shrink-0 items-center">
          <Tooltip
            content={t('ugcRequestShow.topBar.downloadQrCode')}
            placement="bottom"
            theme="primaryDark"
            arrow
          >
            <a
              href={`${ugcRequest.qrCodeUrl}?download=1&size=400`}
              className="ml-1 block shrink-0 rounded-md bg-grey7 p-0.5"
            >
              <img
                src={`${ugcRequest.qrCodeUrl}?border_modules=0`}
                className="h-3 w-3"
                alt="QR Code"
              />
            </a>
          </Tooltip>
          <div className="mx-1.5">
            <div className="hidden desktop:block">
              <ShareUrl url={ugcRequest.url} size="small" />
            </div>
            <div className="block h-4 w-4 rounded-lg bg-grey7 p-0.25 desktop:hidden">
              <div className="flex items-center p-0.5">
                <CopyButton
                  value={ugcRequest.url}
                  className="transition-fast hover:scale-110"
                  tooltipPlacement="bottom"
                  Icon={IconLink}
                />
              </div>
            </div>
          </div>

          <LumenButton
            size="sm"
            color="secondary"
            leftIcon="gear-outline"
            asChild
          >
            <Link
              to={routeFor(
                routes.requests.edit,
                getTypeFromUgcRequest(ugcRequest),
                ugcRequest.id
              )}
            >
              {t('global.edit')}
            </Link>
          </LumenButton>
        </div>
      </div>
    </div>
  );
}
